import React, { Component, Suspense } from "react";
import sectionList from "./sectionList";
import ServiceCall from "services";
import { Global, css } from "@emotion/core";
import { CookiesProvider } from "react-cookie";

// global styles
import globalOverrideStyles from "styling/globalOverrides";
import animStyles from "styling/animations";

class Section extends Component {
  state = {
    data: null
  };

  renderSection() {
    if (!this.state.data) return null;

    const SectionTag = sectionList[this.props.name];

    return (
      <Suspense fallback={null}>
        <Global styles={css(globalOverrideStyles)} />
        <Global styles={css(animStyles)} />
        <CookiesProvider>
          <SectionTag {...this.state.data} />
        </CookiesProvider>
      </Suspense>
    );
  }

  componentDidMount() {
    this.getProps().then(data => {
      this.setState({ data: data });
    });
  }

  getProps = () => {
    return new Promise((resolve, reject) => {
      if (this.props.service)
        this.fetchSectionData().then(data => {
          return resolve(data);
        });
      else {
        const data = JSON.parse(this.props.dataProps);
        return resolve(data);
      }
    });
  };

  fetchSectionData = () => {
    return ServiceCall(this.props.service, { id: this.props.id })
      .then(data => {
        if (data.Result.resultCode === "0") {
          return data.Result.props;
        }
      })
      .catch(err => {
        return null;
      });
  };

  render() {
    return this.renderSection();
  }
}

export default Section;
